<div style="max-width: 90vw">
  <div mat-dialog-title>
    <h5 i18n>Additional Item Usage</h5>
  </div>

  <div mat-dialog-content>
    <form #customItemForm="ngForm" (ngSubmit)="addCustomItem(customItemForm)">
      <p i18n>Please enter information for any items not included on the quote contract</p>

      <div class="form-group row">
        <div class="col-sm-12 form-inline">
          <select name="productFilterItemType_ID" class="form-control"
                  [(ngModel)]="productFilterItemType_ID" (ngModelChange)="refreshProductItemType()">
            <option value="undefined" selected="selected" disabled hidden i18n>Choose Item Type... </option>
            <option [ngValue]="undefined" style="color:black;"> - </option>
            <option *ngFor="let itemType of itemTypes" [ngValue]="itemType.itemType_ID">{{itemType.itemType_Desc}}</option>
          </select>
          <select *ngIf="!productUsage" name="productFilterRValue" class="form-control"
                  [(ngModel)]="productFilterRValue" (ngModelChange)="refreshProductItems()">
            <option value="undefined" selected="selected" disabled="" hidden="" i18n>Choose R-Value... </option>
            <option [ngValue]="undefined" style="color:black;"> - </option>
            <option *ngFor="let rValue of productRValues" [ngValue]="rValue.rValue_ID">{{rValue.rValue_Desc}}</option>
          </select>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-12 form-inline">
          <select name="customItem_ID" class="form-control"
                  required="" appValidateItemCost
                  [(ngModel)]="additionalItem.item_ID" #customItem_ID="ngModel"
                  (ngModelChange)="refreshProductUsages()">
            <option [ngValue]="undefined" selected="selected"> - </option>
            <option *ngFor="let productItem of productItems" [ngValue]="productItem.item_ID">
              <ng-template [ngIf]="productItem.item_Part">{{productItem.item_Part}}, </ng-template>{{productItem.item_Name}}
            </option>
          </select>
          <div *ngIf="customItemForm.submitted && customItemForm.controls['customItem_ID']?.errors?.itemPriceValidator"
               class="alert alert-danger">
            {{customItemForm.controls['customItem_ID']?.errors.itemPriceValidator}}
          </div>
          <div *ngIf="productUsage">
            <span i18n>Coverage:</span>
            <select name="itemUsage_ID" class="form-control"
                    required=""
                    [(ngModel)]="additionalItem.itemUsage_ID" #itemUsage_ID="ngModel">
              <option [ngValue]="undefined" selected="selected"> - </option>
              <option *ngFor="let itemUsage of productUsages" [ngValue]="itemUsage.itemUsage_ID">{{itemUsage.rValue.rValue_Desc}}</option>
            </select>
            <div [hidden]="!customItemForm.submitted || itemUsage_ID.valid"
                 class="alert alert-danger" i18n>Select a coverage</div>
          </div>
          <div [hidden]="!customItemForm.submitted || !customItemForm.controls['customItem_ID']?.errors?.required"
               class="alert alert-danger" i18n>Select a product</div>
        </div>
      </div>

      <div [hidden]="!customItemForm.submitted || customItemForm.valid"
           class="alert alert-danger" i18n>
        Validation issues encountered.  Please review your entered information.
      </div>
      <div class="row">
        <div class="col-sm-4"></div>
        <div class="col-sm-8">
          <button mat-button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
          <button mat-button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
        </div>
      </div>
    </form>
  </div>
</div>
